/** Central route constants. Import these instead of hardcoding strings. */
export const PATHS = {
  home: '/',
  vendors: '/vendors',
  vendorCategory: (category) => `/vendors/${category}`,
  vendorDetail: (vendorId) => `/vendor/${vendorId}`,
  rentals: '/rentals',
  catering: '/catering',
  services: '/services',
  listYourService: '/list-your-service',
  earnWithVgo: '/earn-with-vgo',
  signup: '/signup',
  signupCustomer: '/signup/customer',
  signupForListing: '/signup/customer?next=%2Fvendor-onboarding%2Fbusiness-info',
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  map: '/map',
  budgetBuilder: '/budget-builder',
  messages: '/messages',
  privacy: '/privacy',
  terms: '/terms',
  support: '/support',
  onboarding: '/vendor-onboarding',
  onboardingBusinessInfo: '/vendor-onboarding/business-info',
  onboardingServiceDetails: '/vendor-onboarding/service-details',
  onboardingPhotos: '/vendor-onboarding/photos',
  onboardingPricing: '/vendor-onboarding/pricing',
  onboardingLocation: '/vendor-onboarding/location',
  onboardingAvailability: '/vendor-onboarding/availability',
  onboardingPayment: '/vendor-onboarding/payment',
  dashboard: '/dashboard',
  vendorDashboard: '/dashboard/vendor',
  vendorListings: '/dashboard/vendor/listings',
  vendorAvailability: '/dashboard/vendor/availability',
  vendorBookings: '/dashboard/vendor/bookings',
  vendorCredentials: '/dashboard/vendor/credentials',
  vendorApplications: '/dashboard/vendor/applications',
  vendorApply: (eventId) => `/dashboard/vendor/apply/${eventId}`,
  vendorPayments: '/dashboard/vendor/payments',
  vendorSettings: '/dashboard/vendor/settings',
  customerDashboard: '/dashboard/customer',
  customerBookings: '/dashboard/customer/bookings',
  customerFavorites: '/dashboard/customer/favorites',
  customerOrders: '/dashboard/customer/orders',
  customerEvents: '/dashboard/customer/events',
  customerEventApplications: (eventId) => `/dashboard/customer/events/${eventId}/applications`,
  customerSettings: '/dashboard/customer/settings',
  vendorOrders: '/dashboard/vendor/orders',
  events: '/events',
  eventPage: (slug) => `/events/${slug}`,
  eventOrder: (slug, truckId) => `/events/${slug}/order/${truckId}`,
  eventVendorProfile: (slug, truckId) => `/events/${slug}/vendor/${truckId}`,
  pickupOrder: (vendorId) => `/order/${vendorId}`,
  checkout: (listingId) => `/checkout/${listingId}`,
  paymentSuccess: '/payment/success',
  paymentCancel: '/payment/cancel',
  adminMonitor: '/admin/monitor'
};
